import * as React from 'react';
import X from '@uber/base-icons/x';
import { useStyletron } from 'baseui';
import { Button, KIND, SIZE } from 'baseui/button';
import { PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { HEADER } from '../../../constants/template-builder';
type HeaderActionsPropsT = {
  onClearCanvas: () => void;
  onSaveTemplate: () => void;
  onClose: () => void;
};
const CLOSE_BUTTON_OVERRIDES = ({
  BaseButton: {
    style: ({
      $theme
    }: {
      $theme: {
        sizing: Record<string, string>;
      };
    }) => ({
      paddingLeft: $theme.sizing.scale300,
      paddingRight: $theme.sizing.scale300
    })
  }
} as const);
export function HeaderActions({
  onClearCanvas,
  onSaveTemplate,
  onClose
}: HeaderActionsPropsT) {
  const [css, theme] = useStyletron();
  return <div className={css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.sizing.scale600
  })}>
      <Button onClick={onClearCanvas} kind={KIND.secondary} size={SIZE.small}>
        {HEADER.CLEAR_CANVAS}
      </Button>
      <Button onClick={onSaveTemplate} kind={KIND.primary} size={SIZE.small}>
        {HEADER.SAVE_TEMPLATE}
      </Button>
      <StatefulTooltip content="Close" placement={PLACEMENT.bottom} showArrow>
        <Button data-testid="close-button" onClick={onClose} kind={KIND.tertiary} size={SIZE.small} overrides={CLOSE_BUTTON_OVERRIDES}>
          <X size={16} />
        </Button>
      </StatefulTooltip>
    </div>;
}